export default "assets/images/chateaux-logos/la-garde-977bd8f4.png";